export const HELP_CONTENT = (
  <div>
    <h2>WHAT IT DOES</h2>
    <p>
      An AI assistant will help you schedule time to meet with a group - hopefully, faster than you could before.
    </p>
    <h2>HOW IT WORKS</h2>
    <p>
      <ul>
        <li>
          Respond to the assistant to provide setup info and your availability.
        </li>
        <li>
          Copy the link to share with others and get their availability.
        </li>
        <li>
          Find times to meet outlined in gold, or read the first available time at the bottom of the screen.
        </li>
        <li>
          Hover to see who's available in any slot.
        </li>
      </ul>
    </p>
    <h2>WHEN IT DOESN'T</h2>
    <p>
      <ul>
        <li>
          Sometimes the assistant will get it wrong.
        </li>
        <li>
          Try rewording, use multiple prompts, or use your mouse to fix mistakes.
        </li>
        <li>
          Click twice or click-drag to create a date range or to toggle time slots.
        </li>
      </ul>
    </p>
  </div>
);